import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimActKC2OtherDefaultsGql } from '../../bimWorkOrderQueries';

const requestId = 'bimActKC2OtherDefaults';

export const useBimActKC2OtherDefaults = (workOrderId?: number, withEffect?: boolean) => {
    const [bimActKC2OtherDefaultsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [bimActKC2OtherDefaultsData, bimActKC2OtherDefaultsStatus] = useRequest({
        requestId,
        query: bimActKC2OtherDefaultsGql,
        variables,
        withEffect: withEffect && Boolean(workOrderId),
    });

    useEffect(() => {
        bimActKC2OtherDefaultsReset(undefined);
    }, [bimActKC2OtherDefaultsReset]);

    return {
        bimActKC2OtherDefaultsData,
        bimActKC2OtherDefaultsStatus,
    };
};
